// extracted by mini-css-extract-plugin
module.exports = {"no-stream":"styles_no-stream__3rWkT","loading":"styles_loading__2193E"};